export default function themeScripts() {
  // Prevent the redirect when href is # in navigation links, which is used for dropdowns.
  (function () {
    var anchorTagsElements = document.querySelectorAll('a[href="#"]');

    anchorTagsElements.forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        event.preventDefault();
      });
    });
  })();
}
